import { render, staticRenderFns } from "./IngredientBox.vue?vue&type=template&id=ab5de980&"
import script from "./IngredientBox.vue?vue&type=script&lang=js&"
export * from "./IngredientBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports